import { useCart } from "../context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  return (
    <div className="product-card">
      <div className="product-media">
        <img src={product.image} alt={product.name} loading="lazy" />
      </div>

      <div className="product-info">
        <h3 title={product.name}>{product.name}</h3>
        <div className="product-meta">
          <span className="badge">{product.category}</span>
          <span className="price">₹{product.price.toLocaleString('en-IN')}</span>
        </div>

        <div className="tags">
          {product.tags?.map((t) => (
            <span className="tag" key={t}>{t}</span>
          ))}
        </div>

        <button className="btn-primary" onClick={() => addItem(product)}>
        Add to Cart
      </button>
      </div>
    </div>
  );
}
